import { ENTRYPOINT } from '@/config/entrypoint'

export default {
  buildLoginUrl () {
    return new URL(ENTRYPOINT + '/oidc-login?redirect_target=user')
  },
  handleCodeRedirect (query) {
    const tokenUrl = this.buildLoginUrl()
    for (const k in query) {
      if (Object.prototype.hasOwnProperty.call(query, k)) {
        tokenUrl.searchParams.append(k, query[k])
      }
    }
    return tokenUrl
  }
}
